export default __webpack_public_path__ + "static/media/PropostasVendidas.a0a6d816.svg";